import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditTitle } from '../../../actions/studio';
import { BatchEditTitleOperation } from '../../../types/batchActions';
import { Props } from './TitleBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditTitle'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  batchEditTitle: (operation: BatchEditTitleOperation, title: string) =>
    dispatch(batchEditTitle(operation, title)),
});

export default connect(null, mapDispatchToProps);
